//wow animation function
Visibility.onVisible(function () {
  var wow = new WOW().init();
});
